import { hasLocizeTranslation } from 'lib/utils/locize'

// Keep local EN/TH labels available until the corresponding Locize keys exist.
// The active storefront language is passed in explicitly for SSR and navigation.
const labels = {
  SOLD: ['sold', 'ขายแล้ว'],
  REVIEWS: ['Read reviews', 'อ่านรีวิว'],
  MODEL: ['Model', 'นางแบบ'],
  WEARS: ['wears', 'ใส่ไซซ์'],
  MEASUREMENTS: ['Model measurements', 'สัดส่วนนางแบบ'],
  BUST: ['Bust', 'รอบอก'],
  WAIST: ['Waist', 'รอบเอว'],
  HIPS: ['Hips', 'รอบสะโพก'],
  POLICY: [
    'View eligibility, conditions and return options',
    'ดูสิทธิ์ เงื่อนไข และวิธีการคืนสินค้า',
  ],
  NON_RETURNABLE: ['This item is non-returnable', 'สินค้านี้ไม่สามารถคืนได้'],
  TH_RETURNS: ['30-day returns', 'คืนสินค้าภายใน 30 วัน'],
  RETURN_OPTIONS: [
    'Check eligibility and free return options',
    'ตรวจสอบสิทธิ์และวิธีคืนสินค้าฟรี',
  ],
  RETURNS: ['Returns for this item', 'การคืนสินค้านี้'],
  SELECT_SIZE: ['Select a size', 'เลือกไซซ์'],
  SIZE: ['Size:', 'ไซซ์:'],
  TABLE_SIZE: ['Size', 'ไซซ์'],
  FIT_DETAILS: ['Size and fit details', 'รายละเอียดไซซ์และความพอดี'],
  AI_TRY_ON: ['AI Try-on', 'ลองสวมด้วย AI'],
  FIND_STORE: ['Find in store', 'ค้นหาในร้าน'],
  CHAT: ['Chat with us', 'แชทกับเรา'],
  SHARE: ['Share', 'แชร์'],
}

export const isThaiLanguage = (language = '') =>
  language.toLowerCase().split('-')[0] === 'th'

export const trustFallback = (key, language) =>
  labels[key]?.[isThaiLanguage(language) ? 1 : 0] || ''

export default function trustCopy(t, key, language) {
  return hasLocizeTranslation(
    t,
    `PDP_TRUST_${key}`,
    trustFallback(key, language),
  )
}
